import { Button, IconHeartOff16, IconHeartOn16 } from '@cian/ui-kit';
import { TButtonTheme } from '@cian/ui-kit/button/types';
import * as React from 'react';

export interface IFavoriteButtonProps {
  onClick(event: React.MouseEvent): void;
  theme?: TButtonTheme;
  isFavorite: boolean;
}

export function FavoriteButton({ isFavorite, onClick, theme = 'fill_white_secondary' }: IFavoriteButtonProps) {
  const icon = isFavorite ? <IconHeartOn16 color="error_100" /> : <IconHeartOff16 color="error_100" />;
  const label = isFavorite ? 'В избранном' : 'В избранное';

  return (
    <Button theme={theme} onClick={onClick} beforeIcon={icon} size="XS">
      {label}
    </Button>
  );
}
